module.exports = __webpack_public_path__ + "media/bootstrap-icons/octagon-87e49a1c.svg";